module.exports = __webpack_public_path__ + "static/img/index-icon-1.bd8c9eaf.png";